import { api } from './api';

export interface AiUsage {
  monthCents: number;
  capCents: number | null;
  byModel: { model: string; cents: number; runs: number }[];
  daily: { day: string; cents: number; runs: number }[];
}

export type PaidTier = 'growth' | 'global' | 'enterprise';
export type StripeInterval = 'monthly' | 'yearly';

/** Canonical plan entry from GET /api/billing/plans (Stripe-sourced). */
export interface PlanCatalogEntry {
  code: 'free' | PaidTier;
  monthlyUnitAmountCents: number;
  yearlyUnitAmountCents: number;
  /** Lowercase ISO 4217 — `usd` today. */
  currency: string;
}

export const billingApi = {
  async aiUsage(workspaceId: string): Promise<AiUsage> {
    const r = await api.get<AiUsage>(`/api/billing/workspaces/${workspaceId}/ai-usage`);
    return r.data;
  },
  async plans(): Promise<PlanCatalogEntry[]> {
    const r = await api.get<{ plans: PlanCatalogEntry[] }>(`/api/billing/plans`);
    return r.data.plans;
  },
  async checkout(body: { plan: PaidTier; interval: StripeInterval; seats: number; companyId: string }): Promise<{ url: string }> {
    const r = await api.post<{ url: string }>(`/api/billing/checkout`, body);
    return r.data;
  },
  async portal(companyId: string, returnUrl?: string): Promise<{ url: string }> {
    const r = await api.post<{ url: string }>(`/api/billing/portal`, { companyId, returnUrl });
    return r.data;
  },
  async me(companyId: string): Promise<BillingMe> {
    const r = await api.get<BillingMe>(`/api/billing/me`, { params: { companyId } });
    return r.data;
  },
};

export interface BillingMe {
  hasStripeCustomer: boolean;
  plan?: string;
  billingInterval?: 'monthly' | 'yearly' | null;
  currentPeriodEnd?: string | null;
  cancelAtPeriodEnd?: boolean;
}
